// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class AssetReservationService {

//   constructor() { }
// }



import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { assetPurchaseOrderStatusOptions } from '~/models/modules/Asset/Orders/assetPurchaseOrderStatusOptions';
import { API_NAMES, ApiServiceBase } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class AssetReservationService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }
  purchaseOrderAdded: EventEmitter<any> = new EventEmitter();
  purchaseOrderUpdated: EventEmitter<any> = new EventEmitter();

  getReservationGrid(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }

  getReservationGridList(paramsObj?: any, model?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data-list`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }

  getReservationList(){
    return this.http.get<any>(this._url(`/GetList`));
  }

  getActiveReservationList(){
    return this.http.get<any>(this._url(`/GetActiveList`));
  }
  getReservationById(id : number){
    return this.http.get<any>(this._url(`/${id}`));
  }
  createReservation(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateReservation(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deactivateReservation(id: number) {
    return this.client.put(this._url(`/deactivate/${id}`), {});
  }

   reactivateDeactivateBatchAssetReservation(obj: any) {
    return this.client.put(this._url(`/batchActivateDeactivate`), obj);
  }
  reactivateReservation(id: number) {
    return this.client.put(this._url(`/reactivate/${id}`), {});
  }
  checkAssetForReservation(assetIds: number[], requestedFrom: Date, requestedTo: Date, assetReservationId?: number) {
     const params = {
    assetIds: assetIds,
    requestedFrom: requestedFrom.toISOString(),  // or format as 'yyyy-MM-ddTHH:mm:ss'
    requestedTo: requestedTo.toISOString(),  // or format as 'yyyy-MM-ddTHH:mm:ss'
    assetReservationId: assetReservationId ?? 0,
  };

  return this.http.post(this._url(`/CheckAssetForReservation`), params );
  }

  getListByStatus(status: assetPurchaseOrderStatusOptions, paramsObj?: any,screenSiteId?: number){
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    let params = createHttpParams(paramsObj);
    return this.client.put(this._url(`/by-status/${status}`), status, {
      params,
      observe: 'response',
  });
  }
  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/ReservationTransaction${v}`);
  }

}

